<template>
  <div class="row">
    <div class="col-md-12">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__body">
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
            <h5>
              Relatório do cliente
              <span class="font-weight-bold" v-if="data.company">{{
                data.company.name
                }}</span><br />
              <small v-if="data.invoice && data.invoice.billing_month">referente ao mês
                {{ data.invoice.billing_month | month }}</small>
            </h5>
            <div class="btn-toolbar mb-2 mb-md-0">
              <div class="btn-group d-print-none mr-2">
                <a class="mr-2" href data-toggle="modal" @click="callData()">
                  <button class="btn btn-outline-brand m-btn m-btn--outline">
                    <i class="fas fa-sync-alt"></i> Gerar novo
                  </button>
                </a>

                <a href data-toggle="modal" onclick="window.print();return false;">
                  <button class="btn btn-outline-brand m-btn m-btn--outline">
                    <i class="fas fa-print"></i> Imprimir
                  </button>
                </a>
              </div>

              <div class="d-none d-print-block pt-0 mt-0">
                <div class="m-invoice__logo">
                  <a href="#">
                    <img src="@/assets/media/img/logo/logo_newway.svg" width="200" />
                  </a>
                </div>
                <span class="m-invoice__desc">
                  <span class="text-right mr-1">CNPJ: 17.738.064/0001-97 </span>
                </span>
              </div>
            </div>
          </div>
          <div id="alert" class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
            :class="alert.color" role="alert" v-if="alert.message">
            <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
            <i :class="alert.icon"></i> &nbsp;<strong>{{
              alert.message
              }}</strong><br />
          </div>

          <div v-if="data.customer" id="divCustomer">
            <div class="table-responsive">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h5 class="mt-5 font-weight-bold">Cliente</h5>
              </div>

              <div class="container-table mb-3 mt-3">
                <div class="table-responsive">
                  <table class="table m-table table-striped">
                    <thead>
                      <tr>
                        <th v-show="data.customer.documents.type === 'cnpj'" class="text-left font-weight-bold">
                          Razao Social
                        </th>
                        <th class="text-left font-weight-bold">
                          {{
                            data.customer.documents.type === 'cpf'
                              ? 'Nome'
                              : 'Nome Fantasia'
                          }}
                        </th>
                        <th class="text-left font-weight-bold">
                          {{ data.customer.documents | document_type }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td v-show="data.customer.documents.type === 'cnpj'" class="text-left">
                          {{ data.customer.customerable.co_name }}
                        </td>
                        <td class="text-left">
                          {{ data.customer.customerable.name }}
                        </td>
                        <td class="text-left">
                          {{ data.customer.documents.value | cnpj | cpf }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="data.contractDescription">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h5 class="mt-5">
                  <strong>Descritivo contrato ID -
                    {{ data.invoice.contr_id }}</strong>
                </h5>
              </div>
              <div class="row m-0">
                <div class="col-6" v-for="(items, key) in data.contractDescription" v-bind:key="key">
                  <div class="container-table">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <tbody>
                          <tr v-for="(desc, index) in items" :key="index">
                            <template v-if="desc.amount">
                              <th width="150">{{ index === 0 ? key : '' }}</th>
                              <td width="190">{{ desc.amount }}</td>
                              <td v-if="desc.quantity">{{ desc.quantity }}</td>
                              <td v-if="!desc.quantity">
                                {{ desc.price | moneyDescriptive }}
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="data.invoice.is_csv_consumption">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
                <h5 class="mt-5 font-weight-bold">Informações adicionais</h5>
              </div>
              <div class="font-italic pb-2">Fatura gerada por planilha</div>
            </div>
            <div class="table-responsive" v-if="data.invoiceInfos.length > 0">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
                <h5 class="mt-5 font-weight-bold">
                  Informações contratuais adicionais
                </h5>
              </div>
              <div class="font-italic pb-2" v-for="(demand, key) in data.invoiceInfos" v-bind:key="key">
                {{ demand.description }}
              </div>
            </div>
            <div class="table-responsive">
              <div v-if="data.invoice.prod_id == 7">
                <div
                  class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                  <h5 class="mt-5"><strong>Informações chatbot</strong></h5>
                </div>
                <div class="container-table mb-3 mt-3">
                  {{
                    data.contractNoteChatbot
                      ? data.contractNoteChatbot
                      : 'Sem informações cadastradas '
                  }}
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h5 class="mt-5"><strong>Descrição da fatura</strong></h5>
              </div>
              <div class="container-table mb-3 mt-3">
                <div v-if="data.totals" class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold">Modelo</th>
                        <th class="text-center font-weight-bold">Quantidade</th>
                        <th class="text-center font-weight-bold" v-if="data.invoice.bonuses.length > 0">
                          Bônus utilizado
                        </th>
                        <th class="text-center font-weight-bold" v-if="usingSession()">
                          Bônus Facebook
                        </th>
                        <th class="text-right font-weight-bold">Valor</th>
                        <th class="text-right font-weight-bold" v-if="
                          data.details.some(
                            (el) => el.discount_addition_type !== null
                          )
                        ">
                          Acréscimo / Desconto
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detail, key) in data.totals" :key="detail.id">
                        <td class="text-left" v-if="isNotDetailsService(key)">
                          {{ key }}
                        </td>
                        <td class="text-left special-cell" v-else>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ key }}
                          <small v-if="detail.is_min == 1"> (mínimo)</small>
                        </td>
                        <td :class="[getSpecialClass(key, 'text-center')]">
                          {{ detail.amount }}
                        </td>
                        <td :class="[getSpecialClass(key, 'text-center')]" v-if="data.invoice.bonuses.length > 0">
                          {{ getBonusAmount(key) }}
                        </td>
                        <td :class="[getSpecialClass(key, 'text-center')]" v-if="usingSession()">
                          {{ detail.bonus_used ? detail.bonus_used : 0 }}
                        </td>
                        <td class="text-right" v-if="isNotDetailsService(key)">
                          {{ detail.total | money }}
                        </td>

                        <td :class="[getSpecialClass(key, 'text-right')]" v-else></td>
                        <td v-if="detail.discount_addition_type != null" :class="[getSpecialClass(key, 'text-right')]">
                          <small v-if="detail.discount_addition_type == 1">
                            -</small>
                          <small v-if="detail.discount_addition_type == 2">
                            +</small>
                          {{ detail.discount_addition_value | money }}
                        </td>
                        <td :class="[getSpecialClass(key, 'text-right')]" v-else></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h5 class="mt-5 font-weight-bold">Total</h5>
              </div>
              <div class="container-table mb-3 mt-3">
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-right font-weight-bold">Descrição</th>
                        <th class="text-right font-weight-bold" width="200">
                          Valor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-right">Subtotal:</td>
                        <td class="text-right">
                          {{ data.invoice.price_total | money }}
                        </td>
                      </tr>
                      <tr v-if="data.invoice.price_extra">
                        <td class="text-right">Adicional:</td>
                        <td class="text-right">
                          {{ data.invoice.price_extra | money }}
                        </td>
                      </tr>
                      <tr v-if="data.invoice.discount">
                        <td class="text-right">Desconto:</td>
                        <td class="text-right">
                          {{ data.invoice.discount | money }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td class="text-right font-weight-bold">TOTAL:</td>
                        <td class="text-right font-weight-bold">
                          {{
                            (data.invoice.discount >
                              data.invoice.price_total + data.invoice.price_extra
                              ? 0
                              : data.invoice.price_total +
                              data.invoice.price_extra -
                              data.invoice.discount) | money
                          }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="data.invoice.product.id === 1">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h5 class="mt-5">
                  <strong>Descrição do produto contratado</strong>
                  {{ data.invoice.product.name }}
                </h5>
              </div>

              <div class="container-table mb-3 mt-3">
                <div v-if="data.details.length" class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold">Carteira</th>
                        <th class="text-left font-weight-bold" v-if="hasChannelDetails">Canal</th>
                        <th class="text-left font-weight-bold">Modelo</th>
                        <th class="text-center font-weight-bold">Quantidade</th>
                        <th class="text-right font-weight-bold">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="row in mergedProductDetails">
                        <tr>
                          <td class="text-left">{{ row.carteira }}</td>
                          <td class="text-left" v-if="hasChannelDetails">{{ row.canal }}</td>
                          <td class="text-left">{{ row.modelo }}</td>
                          <td class="text-center">{{ row.quantidade }}</td>
                          <td class="text-right">
                            <span v-if="row.valor != null">{{ row.valor | money }}</span>
                            <span v-else>-</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="
              data.invoice.product.id === 7 &&
              data.chatbotCompanyDetails.length
            ">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h5 class="mt-5">
                  <strong>Descrição do produto contratado</strong>
                  {{ data.invoice.product.name }}
                </h5>
              </div>

              <div class="container-table mb-3 mt-3">
                <div v-if="data.chatbotCompanyDetails.length" class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold">Carteira</th>
                        <th class="text-left font-weight-bold">Modelo</th>
                        <th class="text-left font-weight-bold">CNPJ</th>
                        <th class="text-center font-weight-bold">Quantidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="detail in data.chatbotCompanyDetails" :key="detail.id">
                        <td class="text-left">
                          {{ detail.company ? detail.company.co_name : '-' }}
                        </td>
                        <td class="text-left">
                          {{ detail.type.type }}
                        </td>
                        <td class="text-left">
                          {{ detail.company.cnpj | cnpj }}
                        </td>
                        <td class="text-center">{{ detail.amount }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="
              data.invoice.product.id === 1 &&
              !data.invoice.is_csv_consumption
            ">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
                <h5 class="mt-5 font-weight-bold">Usuários</h5>
              </div>
              <div v-if="!data.users.length" class="font-italic pb-2">
                Sem usuários cadastrados.
              </div>

              <div v-if="data.users.length">
                <div class="container-table mb-3 mt-3">
                  <div class="table-responsive">
                    <table class="table table-striped" style="width: 100%; table-layout: fixed">
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bold" style="width: 7%">
                            ID Carteira
                          </th>
                          <th class="text-left font-weight-bold" style="width: 10%">
                            Carteira
                          </th>
                          <th class="text-left font-weight-bold" style="width: 10%">
                            Usuário
                          </th>
                          <th class="text-left font-weight-bold" style="width: 10%">
                            Email
                          </th>
                          <th class="text-left font-weight-bold" style="width: 9%">
                            Permissão
                          </th>
                          <th class="text-center font-weight-bold" style="width: 10%; word-wrap: break-word">
                            Criação
                          </th>
                          <th class="text-center font-weight-bold" style="width: 9%; word-wrap: break-word">
                            Inativação
                          </th>
                          <th class="text-center font-weight-bold" style="width: 5%">
                            Dias
                          </th>
                          <th class="text-center font-weight-bold" style="width: 10%">
                            Preço faixa
                          </th>
                          <th class="text-center font-weight-bold" style="width: 10%">
                            Preço total
                          </th>
                          <th v-if="data.users[0].message_count != null" class="text-center font-weight-bold"
                            style="width: 9%; word-wrap: break-word">
                            Quantidade
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(user, index) in data.users" :key="index">
                          <td class="text-left">{{ user.ref_id }}</td>
                          <td class="text-left" style="word-wrap: break-word">
                            {{ user.company_name ? user.company_name : '-' }}
                          </td>
                          <td class="text-left" style="word-wrap: break-word">
                            {{ user.user }}
                          </td>
                          <td class="text-left" style="word-wrap: break-word">
                            {{ user.login }}
                          </td>
                          <td class="text-left" style="word-wrap: break-word">
                            {{ user.type === 0 ? 'Operador' : 'Gestor' }}
                          </td>
                          <td class="text-center" style="word-wrap: break-word">
                            {{ user.created | date }}
                          </td>
                          <td class="text-center" style="word-wrap: break-word">
                            {{
                              user.inactivity
                                ? user.inactivity
                                : '0000-00-00' | date
                            }}
                          </td>
                          <td class="text-center" style="word-wrap: break-word">
                            {{ user.days_to_pay }}
                          </td>
                          <td class="text-center" style="word-wrap: break-word">
                            {{ user.price_licence | money }}
                          </td>
                          <td class="text-center" style="word-wrap: break-word">
                            {{ user.total | money }}
                          </td>
                          <td v-if="data.users[0].message_count != null" class="text-center"
                            style="word-wrap: break-word">
                            {{ user.message_count }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="!data.invoice.is_csv_consumption">
              <div v-if="data.waentDetails.length" id="divInfosWaent">
                <div
                  class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
                  <h5 class="mt-5 font-weight-bold">
                    Informações de sessões Whatsapp Enterprise
                  </h5>
                </div>

                <div class="container-table mb-3 mt-3">
                  <div class="table-responsive">
                    <table class="table table-striped" id="tableInfosWaent">
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bold">Carteira</th>
                          <th class="text-left font-weight-bold">
                            Número do Chip
                          </th>
                          <th class="text-left font-weight-bold">Waba</th>
                          <th class="text-left font-weight-bold" v-if="
                            data.invoice.prod_id == 8 &&
                            data.invoice.prod_id == 1
                          ">
                            Quantidade de Sessões
                          </th>
                          <th class="text-left font-weight-bold" v-else>
                            Quantidade
                          </th>
                          <th class="text-left font-weight-bold" v-if="usingSession()">
                            Bônus Facebook
                          </th>
                          <th class="text-left font-weight-bold">Tipo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(waentDetail, index) in data.waentDetails" :key="index">
                          <td class="text-left">
                            {{ waentDetail.ref_id }} -
                            {{ waentDetail.company.co_name }}
                          </td>
                          <td class="text-left">
                            {{ waentDetail.phone_number | phonenumber }}
                          </td>
                          <td class="text-left">
                            {{ waentDetail.waba == 0 ? '' : waentDetail.waba }}
                          </td>
                          <td class="text-left">{{ waentDetail.amount }}</td>
                          <td class="text-left" v-if="usingSession()">
                            {{ waentDetail.bonus_used }}
                          </td>
                          <td class="text-left">{{ waentDetail.type.type }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-if="data.waentNumberDetails.length" id="divNumbersWaent">
                <div
                  class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
                  <h5 class="mt-5 font-weight-bold">
                    Informações de números Whatsapp Enterprise
                  </h5>
                </div>

                <div class="container-table mb-3 mt-3">
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <caption></caption>
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bold">Carteira</th>
                          <th class="text-left font-weight-bold">
                            Número do Chip
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(
waentNumberDetail, index
                          ) in data.waentNumberDetails" :key="index">
                          <td class="text-left">
                            {{ waentNumberDetail.ref_id }} -
                            {{ waentNumberDetail.company.co_name }}
                          </td>
                          <td class="text-left">
                            {{ waentNumberDetail.phone_number | phonenumber }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="
              data.invoice.product.id === 1 &&
              !data.invoice.is_csv_consumption
            ">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom">
                <h5 class="mt-5 font-weight-bold">Números</h5>
              </div>
              <div v-if="!data.numbers.length" class="font-italic pb-2">
                Sem Números cadastrados para {{ numbers }}!
              </div>

              <div v-if="data.numbers.length" id="divNumbers">
                <div class="container-table mb-3 mt-3">
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bold">Carteira</th>
                          <th class="text-left font-weight-bold">
                            Nome do canal
                          </th>
                          <th class="text-left font-weight-bold">
                            Número do Chip
                          </th>
                          <th class="text-left font-weight-bold">
                            Quantidade de Mensagens trocadas
                          </th>
                          <th class="text-left font-weight-bold">
                            Data da Última Mensagem
                          </th>
                          <th class="text-left font-weight-bold">
                            Data de Criação do Canal
                          </th>
                          <th class="text-left font-weight-bold" v-if="!data.ignoreNumberMaintenance">
                            Valor número
                          </th>
                          <th class="text-left font-weight-bold" v-if="!data.ignoreNumberMaintenance">
                            Valor manutenção número
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(number, index) in data.numbers" :key="index">
                          <td class="text-left">
                            {{ number.company_id }} - {{ number.company_name }}
                          </td>
                          <td class="text-left">
                            {{ number.name }}
                          </td>
                          <td class="text-left">
                            {{ number.phone_number | phonenumber }}
                          </td>
                          <td class="text-left">{{ number.message_count }}</td>
                          <td class="text-left">
                            {{ number.last_message_at | datetime }}
                          </td>
                          <td class="text-left">
                            {{ number.created_at | datetime }}
                          </td>
                          <td class="text-left" v-if="!data.ignoreNumberMaintenance">
                            <span v-if="!showMaintenanceValue(number)">{{ number.unit_price | money }}</span>
                            <span v-else> - </span>
                          </td>
                          <td class="text-left" v-if="!data.ignoreNumberMaintenance">
                            <span v-if="showMaintenanceValue(number)">{{ number.unit_price | money }}</span>
                            <span v-else> - </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'ReportInvoiceCustomer',
  components: {},
  data() {
    return {
      data: {},
      demands: [],
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      loading: false,
      countText: {},
    };
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    callData() {
      this.getDatas();
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    getDatas() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };

      this.data = {};

      const url = `${baseApiUrl}/v1/report/invoice/customer/${this.$route.params.customerId}/${this.$route.params.invoiceId}`;
      axios.get(url).then((res) => {
        if (res.data.status === 200) {
          this.clearAlert();
          this.data = res.data.data;
        } else {
          this.alert = {
            color: 'alert-danger',
            icon: 'fas fa-exclamation-triangle fa-lg',
            message: res.data.message,
            reason: '',
          };
        }
      });
    },
    getBonusAmount(key) {
      const bonusAmount = this.data.invoice.bonuses.find(
        (bonus) => bonus.type === key
      );
      return bonusAmount ? bonusAmount.amount : 0;
    },
    usingSession() {
      const bonus = this.data.details.find((detail) => detail.bonus_used);
      if (!bonus) {
        return false;
      }
      return Object.keys(this.data.totals).includes('Sessão  - Serviço');
    },
    isNotDetailsService(key) {
      return (
        key != 'HSM - Ativos Único' &&
        key != 'HSM - Ativos Campanha' &&
        key != 'Mensagens - Mensagem' &&
        key != 'Mensagens - Ativos - Campanha' &&
        key != 'Atendimento /  Protocolo - Protocolo' &&
        key != 'Atendimento /  Protocolo - Ativos Campanha'
      );
    },
    getSpecialClass(key, style) {
      return {
        'special-cell': !this.isNotDetailsService(key),
        [style]: true,
      };
    },
    showMaintenanceValue(number) {
      // Contrato com a flag ativa cobra todos os numeros por faixa, entao
      // nenhuma linha e manutencao — independente da data de criacao.
      if (this.data.ignoreNumberMaintenance) {
        return false;
      }

      const cutoff = new Date('2025-08-01');
      const created = new Date(number.created_at);

      return created >= cutoff;
    },
    _addChannelRows() {},
    _resolveCompanyName() {},
  },
  computed: {
    hasChannelDetails() {
      return this.data.channelDetails && this.data.channelDetails.length > 0;
    },
    mergedProductDetails() {
      const rows = [];
      const details = this.data.details || [];
      const channelDetails = this.data.channelDetails || [];

      const modelLabels = {
        'contact': 'Contatos + Envios de Ativos (Contatos receptivos)',
        'active_unique': 'Contatos + Envios de Ativos (Ativos - único)',
      };

      function resolveCompanyLabel(company) {
        if (!company) return '-';
        return company.id + ' - ' + (company.co_name || '-');
      }

      function addChannelRows(targetRows, channels, companyId, dets) {
        var company = (channels.length && channels[0].company) ? channels[0].company : null;
        if (!company) {
          var det = dets.find(function(d) { return d.company_id == companyId; });
          if (det) company = det.company;
        }
        var companyLabel = resolveCompanyLabel(company);
        var modelOrder = { 'contact': 0, 'active_unique': 1 };
        var sorted = channels.slice().sort(function(a, b) {
          var oa = modelOrder[a.model] !== undefined ? modelOrder[a.model] : 2;
          var ob = modelOrder[b.model] !== undefined ? modelOrder[b.model] : 2;
          return oa - ob;
        });
        sorted.forEach(function(ch) {
          targetRows.push({
            _key: 'channel-' + ch.id,
            carteira: companyLabel,
            canal: ch.channel_name || '-',
            modelo: modelLabels[ch.model] || ch.model,
            quantidade: ch.quantity,
            valor: null,
          });
        });
      }

      // Group channel details by company_id
      const channelsByCompany = {};
      channelDetails.forEach(ch => {
        const compId = ch.company_id || 0;
        if (!channelsByCompany[compId]) channelsByCompany[compId] = [];
        channelsByCompany[compId].push(ch);
      });

      const renderedCompanies = new Set();
      let lastCompanyId = null;

      details.forEach((detail, idx) => {
        const compId = detail.company_id || 0;

        if (lastCompanyId !== null && lastCompanyId !== compId && channelsByCompany[lastCompanyId] && !renderedCompanies.has(lastCompanyId)) {
          addChannelRows(rows, channelsByCompany[lastCompanyId], lastCompanyId, details);
          renderedCompanies.add(lastCompanyId);
        }

        rows.push({
          _key: 'detail-' + detail.id,
          carteira: detail.company ? (detail.company.id + ' - ' + detail.company.co_name) : '-',
          canal: '-',
          modelo: detail.type.type,
          quantidade: detail.amount,
          valor: detail.total,
        });

        lastCompanyId = compId;

        if (idx === details.length - 1 && channelsByCompany[compId] && !renderedCompanies.has(compId)) {
          addChannelRows(rows, channelsByCompany[compId], compId, details);
          renderedCompanies.add(compId);
        }
      });

      Object.keys(channelsByCompany).forEach(compId => {
        if (!renderedCompanies.has(Number(compId)) && !renderedCompanies.has(compId)) {
          addChannelRows(rows, channelsByCompany[compId], compId, details);
        }
      });

      return rows;
    },
  },
  mounted() {
    this.callData();
  },
};
</script>

<style scoped>
.table-striped tbody tr td.special-cell {
  background-color: #f4f5f8;
  border: none;
}
</style>
